<template>
  <el-dialog :title="mode === 'add' ? 'Adauga Penalizare' : 'Modifica Penalizare'" id="popup_dialog"
    :visible.sync="showPopup" class="my-dialog-class" width="75%">
    <el-form label-position="top" :inline="false" :rules="rules" label-width="100%" :model="selectedObject"
      ref="my-form" @submit.prevent="save" v-loading="loadingVisible">
      <el-row :gutter="15">
        <el-col class="input-element">
          <el-form-item label="Utilizator" prop="IdUtilizator">
            <el-select v-model="selectedObject.IdUtilizator" class="full-width" filterable
              placeholder="Cauta utilizator..." :disabled="mode == 'edit'">
              <el-option v-for="item in Info.utilizatori" :key="item.Id" :label="item.Nume" :value="item.Id">
                <span style="float: left">{{ item.Nume }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.TipUtilizator }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col class="input-element">
          <el-form-item label="Luna penalizare" prop="Data">
            <el-date-picker v-model="selectedObject.Data" type="month" placeholder="Selecteaza luna" class="full-width"
              format="MMMM yyyy" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </el-col>

        <el-col class="input-element">
          <el-form-item label="Valoare" prop="Valoare">
            <el-input type="number" class="full-width" v-model="selectedObject.Valoare" placeholder="0"></el-input>
          </el-form-item>
        </el-col>

        <el-col class="full-width">
          <el-form-item label="Motiv / Observatii" prop="Motiv">
            <el-input type="textarea" :rows="3" class="full-width" v-model="selectedObject.Motiv" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="showPopup = false"> Renunta </el-button>
      <el-button type="primary" @click="save"> Salveaza </el-button>
    </span>
  </el-dialog>
</template>

<script>
import BasePage from "@/pages/Admin/BasePage";

export default {
  name: "Utilizatori_penalizari_dialog",
  extends: BasePage,
  data() {
    return {
      showPopup: false,
      mode: "add",
      loadingVisible: false,
      selectedObject: {
        IdUtilizator: "",
        Data: "",
        Valoare: "",
        Motiv: "",
      },
      Info: {
        utilizatori: [],
      },
      rules: {
        IdUtilizator: [{ required: true, message: "Selectati un utilizator", trigger: "change" }],
        Data: [{ required: true, message: "Selectati luna", trigger: "change" }],
        Valoare: [{ required: true, message: "Introduceti valoarea penalizarii", trigger: "blur" }],
      },
    };
  },
  methods: {
    async show_me(id, utilizatori) {
      this.showPopup = true;
      if (utilizatori.length === 0) {
        await this.get_utilizatori();
      } else {
        this.Info.utilizatori = utilizatori;
      }

      if (id == null) {
        this.mode = "add";
        this.selectedObject = {
          IdUtilizator: "",
          Data: new Date(),
          Valoare: "",
          Motiv: ""
        };
        if (this.$refs["my-form"]) this.$refs["my-form"].resetFields();
      } else {
        this.mode = "edit";
        var result = await this.post("utilizatori_penalizari/get_info_item_dialog", {
          id: id,
        });
        this.selectedObject = result.Item;
      }
    },

    async get_utilizatori() {
      var response = await this.post("utilizatori_penalizari/get_all_users");
      this.Info.utilizatori = response.Results || response;
    },

    async save() {
      this.$refs["my-form"].validate(async (valid) => {
        if (valid) {
          this.loadingVisible = true;
          try {
            await this.post("utilizatori_penalizari/save", {
              mode: this.mode,
              object: this.selectedObject,
            });
            this.showPopup = false;
            this.$emit("save");
          } finally {
            this.loadingVisible = false;
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.full-width {
  width: 100%;
}

.input-element {
  width: 33%;
  float: left;
}

@media only screen and (max-width: 600px) {
  .input-element {
    width: 100%;
  }
}
</style>